module.exports = __webpack_public_path__ + "img/champ_de_tournesols.4dffa8de.jpg";